export const fillVert = `
precision mediump float;
attribute highp vec3 POSITION;
attribute highp vec2 TEXCOORD;

uniform highp mat4 MATRIX_MVP;
uniform highp vec4 MainTex_ST;

uniform highp vec4 FillColor;
varying highp vec4 vColor;

void main(void){
    vColor = FillColor;
    gl_Position = MATRIX_MVP * vec4(POSITION, 1.0);
}
`;
//# sourceMappingURL=fillVert.js.map